<template>
	<div class="about">
		<carousel v-if="configData?.product_banner?.length > 0" :img-list="configData?.product_banner" />
		<div class="about_tabs">
			<!-- 绑定当前路由对应的tab名称 -->
			<el-tabs v-model="activeTab" @tab-click="handleTabClick">
				<el-tab-pane label="化学原料药" name="active">
					<active-detail v-if="route.path.includes('/products/activeDetail')" />
					<active-pi v-else-if="activeTab === 'active'" />
				</el-tab-pane>
				<el-tab-pane label="化药中间体" name="inter">
					<inter-ref-med v-if="activeTab === 'inter'" type="inter" />
				</el-tab-pane>
				<el-tab-pane label="生物药" name="bioDrug">
					<bioDrug v-if="activeTab === 'bioDrug'" type="bioDrug" />
				</el-tab-pane>
				<el-tab-pane label="生物药中间体" name="bioDrugIntermediate">
					<bioDrugIntermediate v-if="activeTab === 'bioDrugIntermediate'" type="bioDrugIntermediate" />
				</el-tab-pane>
				<el-tab-pane label="生物催化酶" name="bioEnzyme">
					<bioEnzyme v-if="activeTab === 'bioEnzyme'" type="bioEnzyme" />
				</el-tab-pane>
				<el-tab-pane label="对照品" name="ref">
					<inter-ref-med v-if="activeTab === 'ref'" type="ref" />
				</el-tab-pane>
				<el-tab-pane label="CMO/CDMO业务" name="cmo">
					<cmo v-if="activeTab === 'cmo'" />
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import ActivePi from "./activepi.vue"; 
import interRefMed from "./interRefMed.vue";
import activeDetail from "./activeDetail.vue";
import cmo from "./cmo.vue";
import bioDrug from "./bioDrug.vue";
import bioDrugIntermediate from "./bioDrugIntermediate.vue";
import bioEnzyme from "./bioEnzyme.vue";
const route = useRoute();
const router = useRouter();


// 根据当前路由计算activeTab
const activeTab = computed({
	get() {
		// 从路由路径判断当前是哪个tab
		const path = route.path;
		if (path.includes("/products/active") || path.includes("/products/activeDetail")) {
			return "active";
		}else if (path.includes("/products/inter")) {
			return "inter";
		} else if (path.includes("/products/bioDrugIntermediate")) {
			return "bioDrugIntermediate";
		}else if (path.includes("/products/bioDrug")) {
			return "bioDrug";
		} else if (path.includes("/products/bioEnzyme")) {
			return "bioEnzyme";
		} else if (path.includes("/products/ref")) {
			return "ref";
		} else if (path.includes("/products/cmo")) {
			return "cmo";
		}
		return "";
	},
	set(value) {
		// 当tab切换时，跳转到对应路由
		if (value === "active") {
			router.push("/products/active");
		} else if (value === "inter") {
			router.push("/products/inter");
		} else if (value === "bioDrug") {
			router.push("/products/bioDrug");
		} else if (value === "bioDrugIntermediate") {
			router.push("/products/bioDrugIntermediate");
		} else if (value === "bioEnzyme") {
			router.push("/products/bioEnzyme");
		} else if (value === "ref") {
			router.push("/products/ref");
		} else if( value === "cmo") {
			router.push("/products/cmo");
		}
	}
});


import { useConfigStore } from "../../stores/index";
const store = useConfigStore();
const configData = computed(() => {
	console.log(store.configData, "store.configData");
	return store.configData;
});

// 监听路由变化，确保activeTab正确更新
watch(() => { return route.path; }, (newPath) => {
	console.log("路由变化:", newPath);
}, { immediate: true });

// tab点击处理函数
const handleTabClick = (tab: any) => {
	const tabName = tab.props.name;
	// 直接通过activeTab的setter来处理路由跳转
	activeTab.value = tabName;
};

</script>

<style lang="stylus" scoped>
	.about{
		width 100%
		min-height calc(100% - 70px)
		background-color #fff
		min-width 1200px
		:deep(.el-tabs__active-bar) {
			transition: none !important;
		}
		:deep(.el-tabs__nav-wrap){
			box-shadow: 0px 4px 14px 0px rgba(157,170,197,0.21);
			.el-tabs__nav{
				width 100%
				padding 0 140px
			}
		}
		:deep(.el-tabs__nav-wrap:after) {
			display: none;
		}
		.about_tabs{
			.about_title{
				font-weight: 500;
				font-size: 24px;
				color: #252525;
				line-height: 24px;
				text-align: center;
				margin-top: 73px;
			}
			.about_title_en{
				font-size: 12px;
				color: #C1C1C1;
				line-height: 24px;
				text-align: center;
			}
			.about_content{
				padding 20px 140px
				/* text-align: center; */
				min-height 300px
			}
			.about_content_history{
				.timeline-container {
					position: relative;
					width: 100%;
					min-height: 450px;
					background-color: #FFFFFF;
				}

				/* 节点间连接线 */
				.timeline-connectors {
					position: absolute;
					left: 50%;
					top: 0;
					width: 2px;
					height: 100%;
					transform: translateX(-50%);
					z-index: 1;

					/* 使用伪元素创建节点间的线段 */
					&::before {
						content: '';
						position: absolute;
						left: 0;
						top: 45px; /* 从第一个节点中心开始 */
						width: 2px;
						height: calc(100% - 90px);
						background-color: #E9E9E9;
					}
				}

				/* 事件项 */
				.timeline-item {
					position: absolute;
					left: 0;
					width: 100%;
					height: 90px;
					display: flex;
					align-items: center;
				}

				/* 事件节点圆点 - 默认实心 */
				.timeline-node {
					position: absolute;
					left: 50%;
					transform: translate(-50%, -50%);
					width: 9px;
					height: 9px;
					background-color: #0055A2;
					border-radius: 50%;
					border: 2px solid #0055A2;
					z-index: 2;
					transition: all 0.3s ease;
				}

				/* 高亮节点 - 空心圆形 */
				.timeline-node-active {
					background-color: white;
					border: 3px solid #0055A2;
					width: 12px;
					height: 12px;
				}

				/* 左侧内容区域 */
				.content-left {
					position: absolute;
					left: calc(50% - 277px);
					display: flex;
					align-items: center;
					gap: 15px;
					text-align: right;
				}

				/* 右侧内容区域 */
				.content-right {
					position: absolute;
					left: calc(50% + 31px);
					display: flex;
					align-items: center;
					gap: 15px;
				}

				/* 圆形图标 */
				.icon-circle {
					width: 44px;
					height: 44px;
					border: 2px solid #0055A2;
					border-radius: 50%;
					background-color: #F5F7FA;
					flex-shrink: 0;
					transition: all 0.3s ease;
				}

				/* 文字内容 */
				.text-content {
					display: flex;
					flex-direction: column;
				}

				/* 年份文字 */
				.year {
					font-size: 18px;
					font-weight: 600;
					color: #323232;
					line-height: 1;
					margin-bottom: 6px;
				}

				/* 描述文字 */
				.description {
					font-weight: normal;
					font-size: 12px;
					color: #626262;
					line-height: 22px;
				}
			}
		}
	}
</style>
